import React, { useState } from "react";
import { Row, Col, Spin, Form, Card, Input } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";
import { Tooltip } from "antd";
import { connect } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";

import MainLayout from "../../../../components/layouts/enhancement/MainLayout";
import TopContent from "../../../../components/layouts/enhancement/TopContent";
import cnt from "../../../../services/definedConstant";
import { rightAction } from "../../../../redux/actions";
import {
  labelConfig, staticConfig, apiConfig,
} from "../../treasuryContractBooking.config";
import { BOM } from "../../../../services/definedMethod";

const ConfirmSettlement = (props) => {
  const [form]      = Form.useForm();
  const [isLoading, setIsLoading] = useState(false);
  const navigate    = useNavigate();
  const { id }      = useParams();

  const onFinish = async (values) => {
    try {
      setIsLoading(true);

      const payload = {
        externalReference: values.externalReference,
      };

      // await BOM.SendReq(apiConfig.confirmSettlement, { id, ...payload });
      console.log("ConfirmSettlement payload:", payload);
      BOM.AlertMsg(cnt.SUCCESS, "Settlement confirmed successfully.");
      navigate(-1);
    } catch (error) {
      BOM.AlertMsg(cnt.DANGER, error?.message || "Failed to confirm settlement.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <MainLayout pageItems={staticConfig.manageSettlement}>
      <TopContent pageTitle={labelConfig.settlement} />

      <Spin spinning={isLoading} size="large">
        <div style={{ padding: "24px" }}>
          <Card style={{ boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)", borderRadius: 20 }}>
            <h3 style={{ marginBottom: 24, fontWeight: 600 }}>Confirm Settlement</h3>

            <Form layout="vertical" form={form} onFinish={onFinish}>

              <Row>
                <Col span={12} style={{ padding: "0 8px" }}>
                  <Form.Item
                    label={
                      <span>
                        External Reference
                        <Tooltip title="The custodian or counterparty reference confirming settlement completion.">
                          <InfoCircleOutlined style={{ marginLeft: 4, color: "#667085" }} />
                        </Tooltip>
                      </span>
                    }
                    name="externalReference"
                    rules={[{ required: true, message: "External reference is required" }]}
                  >
                    <Input style={{ height: 44 }} placeholder="e.g. SETTLE-2026-001" />
                  </Form.Item>
                </Col>
              </Row>

              <div style={{ borderTop: "1px solid #EAECF0", margin: "8px 0 20px" }} />

              <Row justify="end">
                <Col>
                  <button
                    type="button"
                    onClick={() => navigate(-1)}
                    style={{ height: 44, padding: "0 24px", borderRadius: 8, border: "1px solid #D0D5DD", background: "#fff", color: "#344054", fontWeight: 600, fontSize: 14, cursor: "pointer", marginRight: 12 }}
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    onClick={() => form.submit()}
                    style={{ height: 44, padding: "0 24px", borderRadius: 8, border: "1px solid #BA24D5", background: "#BA24D5", color: "#fff", fontWeight: 600, fontSize: 14, cursor: "pointer" }}
                  >
                    Confirm Settlement
                  </button>
                </Col>
              </Row>

              <button type="submit" hidden />
            </Form>
          </Card>
        </div>
      </Spin>
    </MainLayout>
  );
};

const mapStateToProps = (state) => ({ rightBtn: state.RightSideBtn });
export default connect(mapStateToProps, { rightAction })(ConfirmSettlement);